'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// Actions


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _booking = require('../../redux/modules/booking');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Status = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    customStatus: state.booking.status,
    loadingAction: state.action.loading,
    loadingInfo: state.booking.loading
  };
}, {
  loadBooking: _booking.load
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Status, _Component);

  function Status() {
    (0, _classCallCheck3.default)(this, Status);
    return (0, _possibleConstructorReturn3.default)(this, (Status.__proto__ || (0, _getPrototypeOf2.default)(Status)).apply(this, arguments));
  }

  (0, _createClass3.default)(Status, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          info = _props.info,
          styles = _props.styles,
          loadingInfo = _props.loadingInfo,
          loadingAction = _props.loadingAction;

      var loading = loadingInfo || loadingAction;
      var self = this;
      var customStatus = '';
      var statusColor = '';

      if (info) {
        var status = info.error ? 'Not Available' : info.data.status;
        var statusVal = status ? status.replace(/\s/g, '').toLowerCase() : null;
        customStatus = self.props.customStatus ? self.props.customStatus : status;

        // status colors
        if (statusVal === 'rejected' || statusVal === 'cancelled' || statusVal === 'drivernotfound') {
          statusColor = 'red';
        } else if (statusVal === 'completed') {
          statusColor = 'green';
        } else {
          statusColor = 'black';
        }
      } else {
        customStatus = 'Not Available';
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'strong',
          { className: styles[statusColor] },
          customStatus,
          _react2.default.createElement('div', { className: styles.loader, style: { display: loading ? 'block' : 'none' } })
        )
      );
    }
  }]);
  return Status;
}(_react.Component), _class2.propTypes = {
  // states
  customStatus: _propTypes2.default.string,
  loadingAction: _propTypes2.default.bool,
  loadingInfo: _propTypes2.default.bool,
  // actions dispatch
  loadBooking: _propTypes2.default.func,
  // actions custom props (set on calling the component)
  info: _propTypes2.default.object,
  styles: _propTypes2.default.object
}, _temp)) || _class);
exports.default = Status;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Status/Status.js
// module id = 865
// module chunks = 0